import React          from 'react';
import moment         from 'moment-timezone'
import * as d3        from "d3"

export default class DataTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    var did = this.props.data.did
    var developerUsageHourly = this.props.data.developerUsageHourly
    if(developerUsageHourly) {
      var dateBegin = developerUsageHourly.dateBegin
      if(dateBegin && dateBegin.isSame(nextProps.data.developerUsageHourly.dateBegin)) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }
  componentDidUpdate() {
    var div = d3.select("#graph" + this.props.data.did + " svg")
    if(div) {
      div.remove()
    }
    this.drawGraph()
  }

  componentDidMount() {
    this.drawGraph()
  }

  drawGraph() {
    var developerUsageHourly = this.props.data.developerUsageHourly
    var did = this.props.data.did

    // set the dimensions and margins of the graph
    var margin = {top: 20, right: 100, bottom: 30, left: 40}
    var width = 960 - margin.left - margin.right
    var height = 125 - margin.top - margin.bottom


    var svg = d3.select("#graph" + did).append("svg:svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .attr("id", did)

    // set the ranges
    var x = d3.scaleTime().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);

    var parseTime = d3.timeParse("%Y-%m-%d %H:%M:%S")
    var bisectDate = d3.bisector(function(d) { return d.time; }).left
    developerUsageHourly.forEach(d => {
      d.time      = parseTime(d.time)
      d.requests  = parseInt(d.requests, 10)
    })

    var line = d3.line()
      .x(function(d) { return x(d.time); })
      .y(function(d) { return y(d.requests); });

    var g = svg.append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var dateEnd = this.props.data.dateEnd.clone()
    var dateStart = this.props.data.dateBegin.clone().set({hour:0,minute:0,second:0,millisecond:0})
    while(dateStart.isBefore(dateEnd)) {
        dateStart = dateStart.add(1, "hours")
        if(!developerUsageHourly.includes(e => e.time === dateStart)) {
            developerUsageHourly.push({
                requests: 0,
                time: dateStart
            })
        }
    }
    // x.dom1ain(d3.extent(developerUsageHourly, function(d) { return d.time; }));
    x.domain([this.props.data.dateBegin.clone().set({hour:0,minute:0,second:0,millisecond:0}), dateEnd]);
    y.domain([d3.min(developerUsageHourly, function(d) { return d.requests; }), d3.max(developerUsageHourly, function(d) { return d.requests; })]);

    g.append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x));

    g.append("g")
        .attr("class", "axis axis--y")
        .call(d3.axisLeft(y).ticks(6).tickFormat(function(d) {
            if(d > 5000)
                return parseInt(d / 1000, 10) + "k";
            else
                return d
        }))
      .append("text")
        .attr("class", "axis-title")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .attr("fill", "#5D6971")
        .text("Requests");

    g.append("path")
        .datum(developerUsageHourly)
        .attr("class", "line")
        .attr("d", line);

    var focus = g.append("g")
        .attr("class", "focus")
        .style("display", "none");

    focus.append("line")
        .attr("class", "x-hover-line hover-line")
        .attr("y1", 0)
        .attr("y2", height);

    focus.append("line")
        .attr("class", "y-hover-line hover-line")
        .attr("x1", width)
        .attr("x2", width);

    focus.append("circle")
        .attr("r", 7.5);

    focus.append("text")
        .attr("x", 15)
        .attr("dy", ".31em");

    svg.append("rect")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
        .attr("class", "overlay")
        .attr("width", width)
        .attr("height", height)
        .on("mouseover", function() { focus.style("display", null); })
        .on("mouseout", function() { focus.style("display", "none"); })
    //     .on("mousemove", mousemove);

    // function mousemove() {
    //   var x0 = x.invert(d3.mouse(this)[0]),
    //       i = bisectDate(developerUsageHourly, x0, 1),
    //       d0 = developerUsageHourly[i - 1],
    //       d1 = developerUsageHourly[i],
    //       d = x0 - d0.time > d1.time - x0 ? d1 : d0;
    //   focus.attr("transform", "translate(" + x(d.time) + "," + y(d.requests) + ")");
    //   focus.select("text").text(function() { return d.requests; });
    //   focus.select(".x-hover-line").attr("y2", height - y(d.requests));
    //   focus.select(".y-hover-line").attr("x2", width + width);
    // }
  }
  render() {
    const {data} = this.props;
    return(
      <div id={'graph' + data.did}>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/DeveloperUsage.js